import { useAuth } from '@/src/context/AuthContext';
import { useTheme } from '@/src/context/ThemeContext';
import { getUserTeamsUseCase } from '@/src/core/dependencies';
import { Team } from '@/src/domain/models';
import { useTranslation } from '@/src/i18n';
import { MyTeamsScreen } from '@/src/presentation/screens/MyTeamsScreen';
import { logger } from '@/src/core/utils';
import { Stack, useFocusEffect, useRouter } from 'expo-router';
import { useCallback, useState } from 'react';

export default function TeamsContainer() {
  const router = useRouter();
  const { colors } = useTheme();
  const { t } = useTranslation();
  const { user } = useAuth();

  const [teams, setTeams] = useState<Team[]>([]);
  const [loading, setLoading] = useState(true);

  useFocusEffect(
    useCallback(() => {
      if (!user) return;
      setLoading(true);
      getUserTeamsUseCase
        .execute(user.id)
        .then(setTeams)
        .catch((error) => logger.error('Teams', 'Failed to load teams', { error }))
        .finally(() => setLoading(false));
    }, [user]),
  );

  return (
    <>
      <Stack.Screen options={{ title: t('navigation.teams') }} />
      <MyTeamsScreen
        teams={teams}
        currentUserId={user?.id || ''}
        loading={loading}
        onTeamPress={(id) => router.push(`/team/${id}`)}
        onCreateTeam={() => router.push('/create-team')}
        colors={colors}
      />
    </>
  );
}
